import { Capacitor } from '@capacitor/core';

/*
  DERIN BAGLANTI (widget -> uygulama)
  -----------------------------------
  Ana ekran widget'ina dokunuldugunda iOS uygulamayi
  "ozturkhukuk://ac/gorevler" gibi bir adresle aciyor. Burada o adresi
  uygulamanin kendi ekranina cevirip oraya gidiyoruz.

  UYGULAMA KAPALIYKEN: iOS acilis adresini de veriyor; getLaunchUrl ile
  onu da okuyoruz. Yoksa kullanici widget'a dokundugunda uygulama aciliyor
  ama ana sayfada kaliyordu.

  YETKI: burada yalnizca adres cevriliyor; hangi ekrani gorup goremeyecegine
  yine uygulamanin kendi yonlendirme korumalari karar veriyor. Yani yetkisiz
  bir kullanici bagi elle yazsa bile o sayfayi goremez.
*/

const HARITA = {
  anasayfa: '/dashboard',
  durusmalar: '/calendar',
  gorevler: '/tasks',
  isler: '/job-list',
  'gider-ekle': '/kisisel-giderler?ekle=1',
  dosyalarim: '/muvekkil',
};

/** "ozturkhukuk://ac/gorevler" -> "/tasks" */
export const adresiCevir = (ham) => {
  if (!ham) return null;
  try {
    const metin = String(ham);
    if (!metin.startsWith('ozturkhukuk://')) return null;
    // "ozturkhukuk://ac/gorevler" -> "ac/gorevler"
    const govde = metin.replace('ozturkhukuk://', '').replace(/^\/+/, '');
    const parcalar = govde.split('/').filter(Boolean);
    if (parcalar[0] !== 'ac' || !parcalar[1]) return null;
    return HARITA[parcalar[1]] || null;
  } catch (e) {
    return null;
  }
};

/**
 * Widget baglantilarini dinlemeye baslar.
 * @param {(yol: string) => void} git  react-router navigate islevi
 */
export const derinBaglantiyiBaslat = async (git) => {
  if (!Capacitor?.isNativePlatform?.()) return;

  let App;
  try {
    ({ App } = await import('@capacitor/app'));
  } catch (e) {
    return;
  }

  const uygula = (ham) => {
    const yol = adresiCevir(ham);
    if (yol) git(yol);
  };

  // Uygulama ACIKKEN widget'a dokunulursa
  try {
    await App.addListener('appUrlOpen', (olay) => uygula(olay?.url));
  } catch (e) { /* yoksay */ }

  // Uygulama KAPALIYKEN widget'a dokunulup acildiysa
  try {
    const acilis = await App.getLaunchUrl();
    if (acilis?.url) uygula(acilis.url);
  } catch (e) { /* yoksay */ }
};
